import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

interface InsuranceIndicatorProps {
  /** Valeur de demandes.assurancevisa : 'oui' | 'traité' | 'non' (ou vide) */
  assurancevisa?: string;
  /** Si fourni, l'icône devient cliquable (ex. tableau principal). Sinon affichage seul. */
  onClick?: (e: React.MouseEvent) => void;
}

/**
 * Indicateur d'assurance unifié :
 * - pas d'icône si 'non' (ou vide)
 * - icône verte (#39FF14) si 'traité'
 * - icône noire sinon ('oui')
 * Utilisé dans le tableau principal ET les vues de facturation pour un rendu identique.
 */
const InsuranceIndicator: React.FC<InsuranceIndicatorProps> = ({
  assurancevisa,
  onClick
}) => {
  if (!assurancevisa || assurancevisa === 'non') return null;

  const isTraite = assurancevisa === 'traité';
  const title = isTraite ? 'Assurance traitée' : 'Assurance souscrite';
  const icon = (
    <AssignmentTurnedInIcon
      fontSize="small"
      style={{ color: isTraite ? '#39FF14' : 'black' }}
    />
  );

  if (onClick) {
    return (
      <Tooltip title={title}>
        <IconButton size="small" onClick={onClick}>
          {icon}
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={title}>
      <span style={{ display: 'inline-flex', verticalAlign: 'middle' }}>{icon}</span>
    </Tooltip>
  );
};

export default InsuranceIndicator;
